type MaybeDate = string | null | undefined;

export const formatPeriodDateRange = ({
  startAt,
  endAt,
  formatDate,
}: {
  startAt: MaybeDate;
  endAt: MaybeDate;
  formatDate: (date: string) => string;
}) => {
  let startAtLabel = '';

  if (startAt === undefined) {
    startAtLabel = '';
  } else if (startAt === null) {
    startAtLabel = 'inception';
  } else {
    startAtLabel = formatDate(startAt);
  }

  return {
    startAtLabel,
    endAtLabel: endAt == null ? 'forever' : formatDate(endAt),
  };
};
